<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="atworkCon flex">
                    <div class="left">
                        <figure>
                            <img src="../../assets/images/cmmnBG/LOGOAtWorks.png" alt="Logo">
                        </figure>
                        <h1>
                            현재 페이지를 <span>준비중</span>입니다.
                        </h1>
                        <p>
                            보다 좋은 서비스를 드리기 위해 준비중입니다. <br>
                            빠른 시일 내에 준비하여 찾아뵙겠습니다.
                        </p>
                    </div>
                    <div class="right">
                        <figure>
                            <img src="../../assets/images/cmmnBG/SSKAtworks.png" alt="Logo">
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    </div>   
</template>

<script>

export default {
    name: 'AtWork',
    components: {
    },
    computed: {
    },
    data() {
        return {
        }
    },
    methods:{
        goback(){
            this.$router.go(-1)
        },
    },
}
</script>

<style scoped>
    .atworkCon {
        justify-content: space-between;
        padding: 80px 0;
    }
    .atworkCon>.left>figure {
        text-align: left;
        margin-bottom: 10px;
    }
    .atworkCon>.left>h1, .atworkCon>.left>p {
        padding-left: 40px;
    }
    .atworkCon>.left>h1 {
        position: relative;
        margin-bottom: 30px;
    }
    .atworkCon>.left>h1:before {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background: #26336A;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        border-radius: 20px;
    }
    .atworkCon>.left>h1>span {
        color: #9E1915;
    }
</style>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>